var _path;
import * as React from "react";
function SvgSingleInsightBorderPositive(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.032 7.457A2.5 2.5 0 0131.5 9.734V33a1.5 1.5 0 01-1.5 1.5H4A1.5 1.5 0 012.5 33V9.734a2.5 2.5 0 011.468-2.277L16.38 1.83a1.5 1.5 0 011.238 0l12.413 5.627z"
  })));
}
export default SvgSingleInsightBorderPositive;